import { render, staticRenderFns } from "./Accessories.vue?vue&type=template&id=1c1a5d41&"
import script from "./Accessories.vue?vue&type=script&lang=js&"
export * from "./Accessories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1a5d41')) {
      api.createRecord('1c1a5d41', component.options)
    } else {
      api.reload('1c1a5d41', component.options)
    }
    module.hot.accept("./Accessories.vue?vue&type=template&id=1c1a5d41&", function () {
      api.rerender('1c1a5d41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Accessories.vue"
export default component.exports